import MultiCarousel from "@stadium/ui/src/components/multi-carousel";
import styles from "./main.module.scss";

const RenderProductCarousel = ({
  children,
  isSwagCreationShopFlow = false,
  showDots = true,
  totalFetchedProducts,
}) => {
  return (
    <main
      className={`${styles.productCarouselCardsContainer} ${
        isSwagCreationShopFlow ? styles.productCardsContainerClass : ""
      }`}
    >
      {isSwagCreationShopFlow && totalFetchedProducts > 0 && (
        <h2 className={styles.storeHeading}>Featured Picks</h2>
      )}

      <MultiCarousel
        arrows
        transitionDuration={500}
        showDots={showDots}
        responsive={{
          superLargeDesktop: {
            breakpoint: { max: 4000, min: 2000 },
            slidesToSlide: 1,
            items: isSwagCreationShopFlow ? 5 : 6,
            partialVisibilityGutter: 50,
          },
          desktop: {
            breakpoint: { max: 1999, min: 1024 },
            slidesToSlide: 1,
            items: isSwagCreationShopFlow ? 5 : 4,
            partialVisibilityGutter: 50,
          },
          tablet: {
            breakpoint: { max: 1023, min: 768 },
            slidesToSlide: 1,
            items: 2,
            partialVisibilityGutter: 50,
          },
          mobile: {
            breakpoint: { max: 767, min: 0 },
            slidesToSlide: 1,
            items: 1,
            partialVisibilityGutter: 5,
          },
        }}
      >
        {children}
      </MultiCarousel>
    </main>
  );
};

export default RenderProductCarousel;
